var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"href":"https://codelinesolutions.com/","target":"_blank"}},[_vm._v("CLS")]),_c('span',{staticClass:"ml-1"},[_vm._v("©SECURE "+_vm._s(new Date().getFullYear())+".")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }